import { PipelineAPI } from '../api/PipelineAPI';
import {
  DestinationPartitionKeyValidationRequest,
  DestinationPrefixValidationRequest
} from '../../shared/interfaces/destination';

export const pipelineNameValidator = async (
  value: string,
  signal: AbortSignal,
  extraParams?: object
) => {
  return PipelineAPI.validateIntegrationName(value, { signal }, extraParams).then(res => ({
    isValid: res.data.valid,
    reason: res.data.reason
  }));
};

export const partitionKeyValidator = async (
  value: DestinationPartitionKeyValidationRequest,
  signal: AbortSignal
) => {
  return PipelineAPI.validateDestinationPartitionKey(value, { signal }).then(res => ({
    isValid: res.data.valid,
    reason: res.data.reason
  }));
};

export const destinationPrefixValidator = async (
  value: DestinationPrefixValidationRequest,
  signal: AbortSignal,
  extraParams?: object
) => {
  return PipelineAPI.validateDestinationPrefix(value, { signal }, extraParams).then(res => ({
    isValid: res.data.valid,
    reason: res.data.reason
  }));
};
